import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Link
} from "@react-pdf/renderer";
import { Icon } from "./components/Icon";

const styles = StyleSheet.create({
  header: {
    marginBottom: 16,
    display: "flex",
    flex: 1,
    justifyContent: "center",
    textAlign: "center"
  },
  name: {
    fontWeight: 700,
    fontSize: 24
  },
  profession: {
    fontSize: 18
  },
  profileCol: {
    display: "flex",
    flexDirection: "col",
    flex: 1,
    fontWeight: "bold"
  },
  profileColIcon: {
    width: 12,
    fontsize: 12,
    color: "#2c67bf"
  },
  profileRow: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start"
  },
  profileColText: {
    textAlign: "left",
    paddingLeft: 12
  },
  profile: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between"
  },
  top: {
    marginBottom: 12
  },
  link: {
    color: "#2c67bf"
  }
});

export const Header = ({
  name,
  phone,
  email,
  website,
  address,
  profession,
  github
}) => {
  return (
    <View style={styles.header}>
      <View style={styles.top}>
        <Text style={styles.name}>{name}</Text>
        <Text style={styles.profession}>{profession}</Text>
      </View>

      <View style={styles.profile}>
        <View style={styles.profileCol}>
          <View style={styles.profileRow}>
            <Icon name={"phone"} style={styles.profileColIcon} />
            <Text style={styles.profileColText}>{phone}</Text>
          </View>

          <View style={styles.profileRow}>
            <Icon name={"envelope"} style={styles.profileColIcon} />
            <Text style={styles.profileColText}>{email}</Text>
          </View>
        </View>

        <View style={styles.profileCol}>
          <View style={styles.profileRow}>
            <Icon name={"github"} style={styles.profileColIcon} />
            <Link
              src={`https://github.com/${github}`}
              style={[styles.profileColText, styles.link]}
            >
              {github}
            </Link>
          </View>

          <View style={styles.profileRow}>
            <Icon name={"globe"} style={styles.profileColIcon} />
            <Link src={website} style={[styles.profileColText, styles.link]}>
              {website}
            </Link>
          </View>
        </View>

        <View style={styles.profileCol}>
          <View style={styles.profileRow}>
            <Icon name={"marker"} style={styles.profileColIcon} />
            <Text style={styles.profileColText}>{address}</Text>
          </View>
        </View>
      </View>
    </View>
  );
};
